besluiten-detail,
reglementen-detail {
  text-align: left;
}

.decision-detail {
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: auto;
  grid-column-gap: 1rem;
  margin: 0 0 30px 0;
  padding: 0 20px 30px 20px;
  border-bottom: 2px solid #005ba9;
  border-radius: 0;
  background-color: white;

  &__title {
    grid-row: 1;
    margin-bottom: 5px;
    font-size: 18px;
    line-height: 32px;

    a {
      font-size: inherit;
      line-height: inherit;
      font-weight: 600;
    }
  }

  &__link {
    border: none;

    &:before {
      content: "";
      position: absolute;
      inset: 0;
      z-index: 1;
    }
  }

  &__list {
    font-size: 0.6rem;
    margin: 0;

    dt {
      position: relative;
      display: inline-block;
      font-weight: 600;
      margin-right: 2px;
    }

    dd {
      position: relative;
      display: inline-block;
      padding: 0;
      margin: 0;
      font-size: 14px;
      line-height: 24px;
    }

    dt ~ dd:not(:last-of-type) {
      margin-inline-end: 0.7em;

      &:after {
        content: "";
        position: absolute;
        top: 0.2rem;
        bottom: 0.2rem;
        right: -0.5em;
        border-right: thin solid currentColor;
      }
    }
  }

  &__status {
    position: relative;
    display: flex;
    align-items: center;
    justify-self: start;
    margin-top: 0.6rem;
    padding: 8px 10px;
    color: #005ba9;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    background-color: #e6f8ff;
    border: 1px solid transparent;

    &::before {
      transform: translateY(0);
    }

    &--true {
      /*
      @extend .icon-checkmark-circle;
      */
      color: #1c5418;
      background-color: #ceeacc;

      &::before {
        font-size: 16px;
      }
    }

    &--false {
      /*
      @extend .icon-cross-circle;
      */
      color: #78081a;
      background-color: #fcc5cf;
    }
  }

  @media (min-width: 768px) {
    grid-template-columns: 1fr auto;
    padding: 0 0 30px 0;

    &__status {
      grid-row: 1;
      grid-column: 2 / -1;
      align-self: start;
      justify-self: end;
      margin: 0;
    }
  }
}
